module.exports = __webpack_public_path__ + "img/image-conoce.961c1fe8.webp";